import React, { useEffect, useRef, useState } from "react";
import styles from "./location.module.css";
import rightArrow from "../../../assets/right_arrow.png";
import { List } from "antd";
import { ImLocation } from "react-icons/im";
import { FiSearch } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TaskSummaryMiddleware from "../../../store/Middlewares/TaskSummaryMiddleware";

function CTSLocations() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const data = state;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const timeout = useRef(null);
  const allLocations = useSelector(state => state.CleanerTaskSummaryReducer.TaskSummaryLocationList)
console.log('data',data)
  useEffect(() => {
    getCleanerLocations();
    getLanguage();
  }, []);



  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };
  const getCleanerLocations = () => {
    let userData = {
      search: search,
      id: data?.id
    }
    dispatch(TaskSummaryMiddleware.getLocation(userData))
  }

  const onSearchLocations = (text) => {
    let userData = {
      search: text,
      id: data?.id
    };
    setSearch(text);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      dispatch(TaskSummaryMiddleware.getLocation(userData))
    }, 500);
  };


  const locations = [
    {
      id: 1,
      address: "Los Angeles, New York City , 8675",
    },
    {
      id: 2,
      address: "Los Angeles, New York City , 8675",
    },
    {
      id: 3,
      address: "Los Angeles, New York City , 8675",
    },
    {
      id: 4,
      address: "Los Angeles, New York City , 8675",
    },
    {
      id: 5,
      address: "Los Angeles, New York City , 8675",
    },
  ];

  const renderItem = (item) => {
    return (
      <div
        className={styles.location_item}
        onClick={() =>
          navigate("/cleanerTaskSummary/CleanerTaskSummary", { state: item })
        }
      >
        <div className={styles.flex}>
          <ImLocation size={35} color={"#f6921e"} />
          <div className={styles.heading_view}>
            <text className={styles.span}>{item?.address}</text>
          </div>
        </div>
        <img
          src={rightArrow}
          className={styles.activeIcon}
        />
      </div>
    );
  };
  const handleChange = value => {
    console.log(value);
  };
  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.main_heading}>{t("Location")}</h1>

      <div className={styles.filter_view}>
        <div style={{ width: '90%', margin: '12px 10px 12px 0px', }}>
          <input
            placeholder={t("Search")}
            onChange={(e) => onSearchLocations(e.target.value)}
            className={styles.search_input}
          />
        </div>
      </div>
      <List dataSource={allLocations} renderItem={renderItem} />
    </div>
  );
}


export default CTSLocations